<template>
    <div
        class="chat_box"
        :class="[is_active ? `!bg-gray-100 border !border-gray-300 ${!has_scroll ? '!min-w-[22rem]' : ''}` : '']"
    >
        <div class="flex justify-between items-center">
            <div class="flex-1 cursor-pointer overflow-hidden mr-4" @click="emits('handleChatClick', contacts)">
                <MutliContactNameIcon
                    :data="
                        contacts.map((contact) => ({
                            ...contact,
                            first_name:
                                contact.first_name ||
                                contact.ll_first_name ||
                                contact.vn_first_name ||
                                contact.ex_first_name ||
                                contact.by_first_name ||
                                contact.sp_first_name ||
                                contact.tn_first_name,
                            last_name:
                                contact.last_name ||
                                contact.tn_last_name ||
                                contact.ll_last_name ||
                                contact.vn_last_name ||
                                contact.ex_last_name ||
                                contact.by_last_name ||
                                contact.sp_last_name ||
                                contact.tn_first_name,
                        })) || []
                    "
                    badgeClass="!bg-[#FF5EAB] z-0"
                    :isShow="true"
                    :isLarge="true"
                />
            </div>

            <div class="cursor-pointer" @click="() => emits('handleClose')">
                <fa :icon="['fal', 'xmark']" class="text-gray-300 text-2xl" />
            </div>
        </div>
    </div>
</template>

<script setup>
import MutliContactNameIcon from "@/components/contacts/MutliContactNameIcon.vue";

const emits = defineEmits(["handleChatClick", "handleClose"]);

const props = defineProps({
    contacts: {
        type: Array,
        default: [],
    },
    is_active: {
        type: Boolean,
        default: false,
    },
    has_scroll: {
        type: Boolean,
        default: false,
    },
});
</script>

<style scoped>
.chat_box {
    @apply w-[14rem] bg-white p-2 rounded-t-md border border-gray-100 shadow-2xl;
}
</style>
